module.exports = __webpack_public_path__ + "img/Mask group.f63050da.png";